import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿Qué es la depresión resistente al tratamiento?",
    answer:
      "La depresión resistente al tratamiento es el trastorno depresivo mayor que no ha mejorado lo suficiente tras probar dos o más antidepresivos con la dosis y duración adecuadas. SAINT® está autorizado por la FDA para adultos en esta situación.",
  },
  {
    question: "¿Qué opciones hay para la depresión resistente al tratamiento?",
    answer:
      "Las opciones incluyen TMS convencional, SAINT®, Spravato (esketamina) y, en algunos casos, combinaciones. La idoneidad se confirma mediante una evaluación psiquiátrica.",
  },
];

export const esFastTrd = makeEsArticle({
  slug: "fast-treatment-resistant-depression-options",
  title: "Opciones rápidas para la depresión resistente al tratamiento",
  description:
    "Opciones para la depresión resistente al tratamiento: SAINT® (cinco días), TMS convencional (seis semanas), Spravato. La idoneidad se confirma mediante una evaluación psiquiátrica.",
  h1: "Opciones rápidas para la depresión resistente al tratamiento",
  breadcrumbLabel: "Opciones para la depresión resistente",
  shortAnswer:
    "La depresión resistente al tratamiento es el trastorno depresivo mayor que no ha mejorado lo suficiente tras probar dos o más antidepresivos. Las opciones incluyen SAINT® (cinco días), TMS convencional (seis semanas) y Spravato (esketamina). La idoneidad se confirma mediante una evaluación psiquiátrica.",
  keyTakeaways: [
    "La depresión resistente al tratamiento no mejora con dos o más antidepresivos.",
    "SAINT® se administra durante cinco días.",
    "La TMS convencional suele durar seis semanas.",
    "Spravato (esketamina) está autorizado por la FDA para la depresión resistente.",
    "La idoneidad se confirma mediante una evaluación psiquiátrica.",
  ],
  sections: [
    {
      heading: "¿Qué es la depresión resistente al tratamiento?",
      paragraphs: [
        "La depresión resistente al tratamiento es el trastorno depresivo mayor que no ha mejorado lo suficiente tras probar dos o más antidepresivos con la dosis y duración adecuadas.",
      ],
    },
    {
      heading: "Opciones de tratamiento",
      paragraphs: [
        "SAINT® se administra durante cinco días y está autorizado por la FDA para el trastorno depresivo mayor en adultos que no han mejorado con antidepresivos.",
        "La TMS convencional suele durar seis semanas y está ampliamente cubierta por los seguros para el trastorno depresivo mayor.",
        "Spravato (esketamina nasal) está autorizado por la FDA para la depresión resistente al tratamiento y se administra en una clínica certificada con monitorización.",
      ],
    },
    {
      heading: "Cómo decidir",
      paragraphs: [
        "No hay una respuesta universal. La idoneidad depende del diagnóstico, el historial de tratamiento y otros factores. Una evaluación psiquiátrica es el primer paso. [[Solicite una consulta|/es/saint]] o llame al 954-827-9793.",
      ],
    },
  ],
  faqs,
  sources: [],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
